import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonAddNewComponent } from '@shared/components/button-add-new/button-add-new.component';
import { ExpansionPanel, ExpansionPanelMenuAction } from '@shared/components/expansion-panel/expansion-panel.component';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { ActivitéFormService } from '../activité-form.service';

@Component({
  selector: 'app-supports',
  imports: [
    HlmFieldImports,
    HlmInputImports,
    ExpansionPanel,
    ButtonAddNewComponent,
    ReactiveFormsModule,
    HlmSelectImports,
    BrnSelectImports,
  ],
  templateUrl: './supports.component.html',
})
export class SupportsComponent {
  readonly formService = input.required<ActivitéFormService>();

  readonly supportActions: ExpansionPanelMenuAction<number>[] = [
    {
      icon: 'lucideTrash',
      label: 'Supprimer',
      action: (idx) => this.formService().supports.removeAt(idx!),
      invisible: () => this.formService().form.disabled,
    },
  ];

  ajouterSupport = () => this.formService().ajouterSupport();
}
